import styled, { css } from 'styled-components';
import { resetBtn } from 'styled-manila';

// Import icons individually for better code splitting
import ThumbsUp from 'core/icons/ThumbsUp';
import Triangle from 'core/icons/Triangle';

import { getColor } from 'core/utils/Styles';
import { bounce } from 'core/utils/KeyFrames';

export const BounceWrapper = styled.div`
	${props => !props.bounce ? '' : css`
		animation: ${bounce} 0.5s ease-in-out 0s;
	`}
`;

export const VoteCount = styled.div`
	letter-spacing: 0.2px;
	font-size: 14px;
	font-weight: 600;
	height: 16px;
	color: ${getColor('darkTeal')};
`;

export const VoteBtn = styled.button`
	${resetBtn}
	width: 18px;
	height: 18px;
`;

export const ThumbVoteBtn = styled(VoteBtn)`
	display: flex;
	flex-direction: row;
	align-items: center;
	width: auto;
	white-space: nowrap;
	margin-left: 4px;
	height: 20px;
	line-height: 16px;

	${VoteCount} { margin-left: 6px; }
`;

export const ThumbsUpIcon = styled(ThumbsUp)`
	min-width: 16px;
	height: 16px;
`;

export const ThumbsDownIcon = styled(ThumbsUpIcon)`
	transform: rotate(180deg);
`;

export const UpVoteIcon = styled(Triangle)`
	width: 100%;
	height: 100%;
`;

export const DownVoteIcon = styled(UpVoteIcon)`
	transform: rotate(180deg);
`;
